import itemComponent from './drawItem.vue'
import rewardItemComponent from './rewardItem.vue'

const Item = {
  install: function (Vue) {
    Vue.component('Item', itemComponent)
    Vue.component('Reward', rewardItemComponent)
  }
}
export default Item



// WEBPACK FOOTER //
// ./src/components/items/index.js